export const enum MutationCacheKey {
  ObserveStudent = 'observeStudent',
  UnObserveStudent = 'unObserveStudent',
}
